/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_BlankInputs */

const zh_print_blank = /** @type {(inputs: Print_BlankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打印空白试卷`)
};

const en_print_blank = /** @type {(inputs: Print_BlankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Print Blank Paper`)
};

const es_print_blank = /** @type {(inputs: Print_BlankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imprimir en blanco`)
};

/**
* | output |
* | --- |
* | "Print Blank Paper" |
*
* @param {Print_BlankInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const print_blank = /** @type {((inputs?: Print_BlankInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_BlankInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_print_blank(inputs)
	if (locale === "en") return en_print_blank(inputs)
	return es_print_blank(inputs)
});